class CartInlineAddons extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    this.addEventListener('change', (event) => {
      const select = event.target.closest('[data-addon-variant]');
      if (!select) return;
      const card = select.closest('.ks-cart-addon__card');
      const price = card?.querySelector('[data-addon-price]');
      if (price) price.textContent = this.formatMoney(Number(select.selectedOptions[0]?.dataset.price || 0));
    });
    this.addEventListener('click', (event) => {
      const button = event.target.closest('[data-addon-add]');
      if (button) this.add(button);
    });
  }

  formatMoney(cents) {
    const currency = window.Shopify?.currency?.active || 'USD';
    return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
  }

  async add(button) {
    const card = button.closest('.ks-cart-addon__card');
    const select = card.querySelector('[data-addon-variant]');
    const message = card.querySelector('[data-addon-message]');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    message.textContent = '';
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [{ id: Number(select.value), quantity: 1 }], sections: ['mini-cart'] })
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Unable to add this item.');
      if (this.dataset.cartPage === 'true') {
        window.location.reload();
        return;
      }
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((res) => res.json());
      cart.sections = result.sections;
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart, openMiniCart: false } }));
    } catch (error) {
      message.textContent = error.message || 'Unable to add this item.';
      button.disabled = false;
      button.removeAttribute('aria-busy');
    }
  }
}

if (!customElements.get('cart-inline-addons')) customElements.define('cart-inline-addons', CartInlineAddons);
